// extracted by mini-css-extract-plugin
module.exports = {"title":"room_price_breakdown_title__1DCUR","total":"room_price_breakdown_total__17riS","price":"room_price_breakdown_price__20PQl"};